module.exports = __webpack_public_path__ + "static/media/HCMM021.55c88c4f.jpg";